import { render, staticRenderFns } from "./igt-notification.vue?vue&type=template&id=c18bba3c&scoped=true&"
import script from "./igt-notification.vue?vue&type=script&lang=js&"
export * from "./igt-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18bba3c",
  null
  
)

export default component.exports